<template>
<div>
	<b-container>
		<b-col :class="{
			'center_row':center
		}">
			<h1 class="h4 text-secondary">HME Rotary Ltd</h1>
			<b-row class="mb-3">
				
				<i class="text-secondary material-icons pr-3">navigation</i>
				<a target="_blank" href="https://goo.gl/maps/JNhBvMjpbMvYE45g9">10-16 Arbury Ave, Coventry CV6 6FB, West Midlands</a>
			</b-row>
			<b-row class="mb-3">
				<i class="text-secondary material-icons pr-3">local_phone</i>
				<a target="_blank" href="tel:00442476661357">024 7666 1357</a>
			</b-row>
		</b-col>
	</b-container>
</div>
</template>
<script>
export default {
  name: 'Contact',
  props: {
    msg: String,
    center:{
    	type:Boolean,
    	default:true
    },
  }
}
</script>